import "styles/reset.css";
import "styles/globals.css";
import Home from "pages/Home";
import ScrollToTop from "components/common/ScrollToTop";

function App() {
  return (
    <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-gray-900">
      <Home />
      <ScrollToTop />
    </div>
  );
}

export default App;
